import { render, staticRenderFns } from "./InformModal.vue?vue&type=template&id=66917d58&scoped=true"
import script from "./InformModal.vue?vue&type=script&lang=js"
export * from "./InformModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66917d58",
  null
  
)

export default component.exports